import { inject, Injectable } from "@angular/core";
import { CandidateStatusEnum } from "app/modules/manage/workflow/recruit/candidate/constants";
import { REQUEST_CANDIDATE_STATUS } from "app/modules/manage/workflow/task/workflow-task.constant";
import { STATUS_IN_DATABASE } from "app/shared/common/constants/Status.constant";
import { ACT_LOG_ACTION } from "app/shared/common/utils/graphql/graphql.constant";
import { GRAPHQL_MUTATION } from "app/shared/common/utils/graphql/graphql.mutation.constant";
import { GRAPHQL_QUERY } from "app/shared/common/utils/graphql/graphql.query.constant";
import { GraphQLService } from "app/shared/common/utils/graphql/graphql.service";
import { UtilCommon } from "app/shared/common/utils/UtilCommon";
import { from, map } from "rxjs";

@Injectable({ providedIn: 'root' })
export class RequisitionGraphQlService {
  #graphQl: GraphQLService = inject(GraphQLService);

  // insertRecommender(objects: Object) {
  //   const query = `
  //       mutation XHuntMutationInsertRecruitRequisitionRecommender($objects: [recruit_rstb_requisition_recommender_insert_input!] = {}) {
  //           insert_recruit_rstb_requisition_recommender(objects: $objects) {
  //           affected_rows
  //               returning {
  //                   aggId
  //               }
  //           }
  //       }
  //   `
  //   return from(
  //     this.#graphQl.mutatePromiseWithVariable(query, {
  //       objects
  //     })
  //   )
  // }

  // createCandidateRecommender(objects: Object) {
  //   const query = `mutation XHuntMutationInsertRecruitRequisitionCandidateRecommender($objects: [recruit_requisition_candidate_recommender_insert_input!] = {}) {
  //     insert_recruit_requisition_candidate_recommender(objects: $objects) {
  //       affected_rows
  //       returning {
  //         id
  //       }
  //     }
  //   }
  //   `

  //   return from(
  //     this.#graphQl.mutatePromiseWithVariable(query, {
  //       objects
  //     })
  //   )
  // }

  hrmQueryRstbRequisitionCandidateWhere(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionCandidateWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where
    }));
  }

  hrmQueryRstbRequisitionCandidateForValidTransferWhere(requisitionId: any) {
    // const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, requisitionId: { _eq: requisitionId } };
    // const where1 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, id: { _eq: requisitionId } }
    const _eq = STATUS_IN_DATABASE.ACTIVE;
    const _eq1 = requisitionId;
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionCandidateForValidTransferWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      _eq, _eq1
    }));
  }

  updateRequisitionRecommender(_eq: String, _set: Object) {
    const query = GRAPHQL_MUTATION.hrmUpdateRstbRequisitionRecommender.query;
    return from(
      this.#graphQl.mutatePromiseWithVariable(query, {
        _eq, _set
      })
    )
  }

  // queryRequisitionRecommender(aggId: string) {
  //   const where = { aggId: { _eq: aggId } };
  //   const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionRecommenderWhere.query;
  //   return from(this.#graphQl.mutatePromiseWithVariable(query, {
  //     where
  //   })).pipe(
  //     map((data: any) => data?.data)
  //   );
  // }

  queryParticipantReward(winnerId: number) {
    const where = { winnerId: { _eq: winnerId } };
    const query = GRAPHQL_QUERY.hrmQueryPstbEventDrawWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where
    })).pipe(
      map((data: any) => data?.data?.[0] || null)
    );
  }

  queryRstbRequisitionForMatchingWhenApproveWhere(where: Object) {
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionForMatchingWhenApproveWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, { where })).pipe(
      map((item) => item?.data)
    )
  }

  createRecruitRequisitionCandidate(_eq: String, _set: any, objects: Object) {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    _set = { ..._set, ...this.#graphQl.getDefaultMutationObject(false) };
    // const query = `
    // mutation XHuntMutationInsertRecruitRequisitionCandidate($where: hrm_hrtb_candidate_bool_exp = {}, $_set: hrm_hrtb_candidate_set_input = {}, $objects: [recruit_rstb_requisition_candidate_insert_input!] = {}) {
    //   updateCandidate: update_hrm_hrtb_candidate(where: $where, _set: $_set) {
    //     affected_rows
    //   }
    //   data: insert_recruit_rstb_requisition_candidate(objects: $objects) {
    //     affected_rows
    //     returning {
    //       aggId
    //       id
    //     }
    //   }
    // }
    // `
    const query = GRAPHQL_MUTATION.hrmInsertRstbRequisitionCandidateForJobApply.query;
    return from(
      this.#graphQl.mutatePromiseWithVariable(query, {
        _eq,
        _set,
        objects
      })
    )
  }

  queryCheckQuantityOfferDoneCandidateInRequisitionAndCandidateStatus(requisitionId: any, candidateId: any) {
    // let query = `
    //     query MyQuery {
    //       requisition: recruit_rstb_requisition(where: {recordStatus: {_eq: "O"}, id: {_eq: ${requisitionId}}}) {
    //         jobs: rstb_requisition_jobs {
    //           jobQuantity
    //         }
    //       }
    //       requisitionAggregate: recruit_rstb_requisition_candidate_aggregate(where: {recordStatus: {_eq: "O"}, status: {_in: ["${REQUEST_CANDIDATE_STATUS.OFFER}", "${REQUEST_CANDIDATE_STATUS.DONE}"]}, requisitionId: {_eq: ${requisitionId}}}) {
    //         aggregate {
    //           count(columns: aggId, distinct: true)
    //         }
    //       }
    //       requisitionAggregateOther: recruit_rstb_requisition_candidate_aggregate(where: {recordStatus: {_eq: "O"}, status: {_nin: ["${REQUEST_CANDIDATE_STATUS.OFFER}", "${REQUEST_CANDIDATE_STATUS.DONE}", "${REQUEST_CANDIDATE_STATUS.CLOSE}", "${REQUEST_CANDIDATE_STATUS.FAIL}", "${REQUEST_CANDIDATE_STATUS.CANCEL}", "${REQUEST_CANDIDATE_STATUS.CANCEL_ONBOARDING}"]}, requisitionId: {_eq: ${requisitionId}}}) {
    //         aggregate {
    //           count(columns: aggId, distinct: true)
    //         }
    //       }
    //       candidateInfos: hrm_hrtb_candidate(where: {recordStatus: {_eq: "O"}, id: {_eq: ${candidateId}}, status: {_in: ["${CandidateStatusEnum.OPENING}", "${CandidateStatusEnum.PROCESSING}", "${CandidateStatusEnum.EMPLOYEE}"]}}) {
    //         id
    //         status
    //         staffMovementFlg
    //         changeEmpTypeFlg
    //       }
    //     }`;
    const recordStatus = STATUS_IN_DATABASE.ACTIVE;
    const statusRequisitionAgg = { _in: [REQUEST_CANDIDATE_STATUS.OFFER, REQUEST_CANDIDATE_STATUS.DONE] }
    const statusRequisitionAggOther = { _nin: [REQUEST_CANDIDATE_STATUS.OFFER, REQUEST_CANDIDATE_STATUS.DONE, REQUEST_CANDIDATE_STATUS.CLOSE, REQUEST_CANDIDATE_STATUS.FAIL, REQUEST_CANDIDATE_STATUS.CANCEL, REQUEST_CANDIDATE_STATUS.CANCEL_ONBOARDING] }
    const statusCandidate = { _in: [CandidateStatusEnum.OPENING, CandidateStatusEnum.PROCESSING, CandidateStatusEnum.EMPLOYEE] }
    const query = GRAPHQL_QUERY.hrmQueryCheckQuantityOfferDoneCandidate.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      recordStatus,
      requisitionId,
      candidateId,
      statusRequisitionAgg,
      statusRequisitionAggOther,
      statusCandidate
    }));
  }

  createRequisitionAttachment(objects: Object) {
    // const query = `
    //   mutation XHuntMutationInsertRecruitRequisitionAttachment($objects: [recruit_rstb_requisition_attachment_insert_input!] = {}) {
    //     data: insert_recruit_rstb_requisition_attachment(objects: $objects) {
    //       affected_rows
    //       returning {
    //         aggId
    //       }
    //     }
    //   }
    // `
    const query = GRAPHQL_MUTATION.hrmInsertRstbRequisitionAttachment.query;
    return from(
      this.#graphQl.mutatePromiseWithVariable(query, {
        objects
      })
    )
  }

  updateRequisitionJob(_eq: String, data: Object) {
    //   const query = `
    //     mutation XHuntMutationUpdateRecruitRequisitionJob($where: recruit_rstb_requisition_job_bool_exp = {}, $_set: recruit_rstb_requisition_job_set_input = {}) {
    //     data: update_recruit_rstb_requisition_job(where: $where, _set: $_set) {
    //       affected_rows
    //       returning {
    //         aggId
    //       }
    //     }
    //   }
    // `
    const query = GRAPHQL_MUTATION.hrmUpdateRstbRequisitionJob.query;
    return from(
      this.#graphQl.mutatePromiseWithVariable(query, {
        _eq,
        _set: data
      })
    )
  }

  updateRequisitionByCode(_eq: String, _set: Object) {
    //   const query = `
    //     mutation XHuntMutationUpdateRecruitRequisition($where: recruit_rstb_requisition_bool_exp = {}, $_set: recruit_rstb_requisition_set_input = {}) {
    //     data: update_recruit_rstb_requisition(where: $where, _set: $_set) {
    //       affected_rows
    //       returning {
    //         aggId
    //       }
    //     }
    //   }
    // `
    const query = GRAPHQL_MUTATION.hrmUpdateRstbRequisitionByCode.query;
    return from(
      this.#graphQl.mutatePromiseWithVariable(query, {
        _eq,
        _set
      })
    )
  }

  getRerferenceCheck(whereClause: Object) {
    const query = GRAPHQL_QUERY.hrmQueryRstbReferenceCheckWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      where: whereClause
    }));
  }

  getRequisitionCandidateAndRequestCode(candidateId: any) {
    const _eq = candidateId;
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionCandidateWithRequisitionWhere.query;
    return from(this.#graphQl.mutatePromiseWithVariable(query, {
      _eq
    }));
  }
}